export default {
  login({ commit }, payload) {
    commit("setToken", payload);
  },

  logout({ commit }) {
    commit("removeToken");
  },
};
